/** Colours of the pathway status pill and the path-type badge, shared by the list, the builder and the dashboard. */
export const STATUS_PILL = Object.freeze({
  draft: "bg-eh-cream-deep text-eh-muted",
  published: "bg-emerald-100 text-emerald-800",
  archived: "bg-slate-100 text-slate-600",
});

export const TYPE_BADGE = "bg-eh-ochre/15 text-eh-ochre-deep";
